<template>
  <v-dialog
      @click:outside="closeDialog()"
      @keydown.esc="closeDialog()"
      scrollable
      v-model="show"
  >
    <v-card>
       <span>
        <v-btn
            @click="closeDialog()"
            icon
            style="position: absolute; right:0;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </span>
      <card-prin-document-btn
          name="Печать"
          :link="getLinkForPrint"
          :token="token"
          type="blue"
          style="margin: 20px 20px 10px"
      />
      <v-card-title class="d-flex flex-column align-start">
        <slot name="title">
          <h3>Загрузка сканов</h3>
        </slot>
      </v-card-title>
      <v-divider/>
      <v-card-text style="padding: 0">
        <scan-card
            :item="getFile"
            :disabled="!getFile.disabled"
            :upload-to-serv-now="loadingFileToServer.identifier === getFile.identifier && loadingFileToServer.value"
            @delete-file="deleteFile($event)"
            @replace-file="replaceFile($event)"
            @upload-file="uploadFile($event)"
            :token="token"
            id="fileId"
            style="border-bottom: 1px solid #E5E5E5; padding: 0 24px 10px 24px"
        />
      </v-card-text>
      <v-card-actions class="d-flex flex-column align-start actions-p">
        <slot :close="closeDialog" name="actions">
          <p class="ml-4">В один раздел документы сканируются одним файлом!</p>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import request from "@/services/request";
import ScanCard from "@/components/cards/scanCard";
import CardPrinDocumentBtn from "@/components/UI/cardPrinDocumentBtn";

export default {
  name: "scansDialog",
  components: {
    ScanCard,
    CardPrinDocumentBtn
  },
  data() {
    return {
      loadingFileToServer: {
        value: false,
        identifier: ''
      },
      files: null,
      loadedFiles: false,
    }
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    orgId: {
      type: Number,
      default: null
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.initFiles()
  },
  mounted() {
    this.getDocuments()
  },
  computed: {
    ...mapGetters('keycloak', {getBlock: "getBlock"}),

    getCurrentPath() {
      return this.$route.path.slice(1)
    },

    getFile() {
      let type
      switch (this.getCurrentPath) {
        case 'singleTable1':
          type = 'BSMA';
          break;
        case 'singleTableOnlyMag':
          type = 'DOP_MAG';
          break;
        case 'singleTable2':
          type = 'POSTGRADUATE';
          break;
        case 'singleTable3':
          type = 'INTERNSHIP';
          break;
        case 'singleTable4':
          type = 'PAID_BSM';
          break;
        case 'singleTable5':
          type = 'PAID_ASSIST';
          break;
        case 'singleTable6':
          type = 'PAID_POSTGRADUATE';
          break;
        case 'singleTable7':
          type = 'PAID_INTERSHIP';
          break;
      }
      let file = this.files.filter(file => file.identifier === type)[0]
      file.disabled = this.getBlock[file.identifier]
      return file
    },
    getLinkForPrint() {
      let link
      switch (this.getCurrentPath) {
        case 'singleTable1':
          link = `/api/report/places/bsm/${this.orgId}`;
          break;
        case 'singleTableOnlyMag':
          link = `/api/report/places/mag/${this.orgId}`;
          break;
        case 'singleTable2':
          link = `/api/report/places/asp/${this.orgId}`;
          break;
        case 'singleTable3':
          link = `/api/report/places/ord/${this.orgId}`;
          break;
        case 'singleTable4':
          link = `/api/report/places/paid-bsm/${this.orgId}`;
          break;
        case 'singleTable5':
          link = `/api/report/places/paid-assist/${this.orgId}`;
          break;
        case 'singleTable6':
          link = `/api/report/places/paid-postgraduate/${this.orgId}`;
          break;
        case 'singleTable7':
          link = `/api/report/places/paid-internship/${this.orgId}`;
          break;
      }
      return link

    }
  },
  methods: {
    initFiles() {
      this.files = [
        {
          name: 'Приложение 1 "Места для приема граждан по всем видам бюджета (бакалавриат, специалитет, магистратура, ассистентура-стажировка)"',
          identifier: 'BSMA',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 1 "Места для приема граждан по всем видам бюджета (магистратура)"',
          identifier: 'DOP_MAG',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 2 "Места для приема граждан по всем видам бюджета (аспирантура)"',
          identifier: 'POSTGRADUATE',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 3 "Места для приема граждан по всем видам бюджета (ординатура)"',
          identifier: 'INTERNSHIP',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 4 "Места для приема граждан по договорам об оказании платных образовательных услуг (по программам бакалавриата, специалитета, магистратуры)"',
          identifier: 'PAID_BSM',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 5 "Места для приема граждан по договорам об оказании платных образовательных услуг (по программам ассистентуры-стажировки)"',
          identifier: 'PAID_ASSIST',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 6 "Места для приема граждан по договорам об оказании платных образовательных услуг ((по программам подготовки научных и научно-педагогических кадров в аспирантуре)"',
          identifier: 'PAID_POSTGRADUATE',
          types: ['application/pdf'],
          disabled: true,
        },
        {
          name: 'Приложение 7 "Места для приема граждан по договорам об оказании платных образовательных услуг (по программам ординатуры)"',
          identifier: 'PAID_INTERSHIP',
          types: ['application/pdf'],
          disabled: true,
        },
      ]
    },
    ...mapActions('notification', {addNotification: 'setNotification'}),
    closeDialog() {
      this.$emit('closeScanDialog');
    },
    async getDocuments() {
      this.loadedFiles = false;
      try {
        const res = await request({
          endpoint: `/api/file/scan/${this.orgId}`,
          method: 'GET',
          token: this.token,
        });
        res.data.forEach(el => {
          const overlapIndex = this.files.findIndex(file => file.identifier === el.scanType);
          if (overlapIndex !== -1) {
            this.$set(this.files, overlapIndex, {...this.files[overlapIndex], ...el})
          }
        });
        this.loadedFiles = true;
      } catch (e) {
        this.loadedFiles = true;
      }
    },
    async uploadFile(event) {
      const fd = new FormData();
      fd.append('orgID', this.orgId);
      fd.append('file', event.file);
      fd.append('scanType', event.identifier);
      this.loadingFileToServer.value = true;
      this.loadingFileToServer.identifier = event.identifier;
      try {
        await request({
          endpoint: '/api/file/scan/upload',
          method: 'POST',
          body: fd,
          token: this.token,
          headers: {"Content-Type": 'multipart/form-data'}
        });
        await this.getDocuments();
        this.loadingFileToServer.value = false;
      } catch (e) {
        this.loadingFileToServer.value = false;
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка загрузки',
          timeout: 3000
        })
      }
    },
    async deleteFile(event) {
      try {
        const response = await request({
          endpoint: `/api/file/scan/delete?fileId=${event.id}`,
          method: 'DELETE',
          token: this.token,
        });
        if (response.status === 200) {
          const ind = this.files.findIndex(file => file.identifier === event.identifier);
          this.files.splice(ind, 1, {
                name: this.files[ind].name,
                identifier: event.identifier,
                types: this.files[ind].types
              }
          )
        }
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка удаления',
          timeout: 3000
        });
        console.log("e delete", e)
      }
    },
    async replaceFile(event) {
      await this.deleteFile(event)
      await this.uploadFile(event)
    },
  },
}
</script>

<style lang="sass">
.actions-p
  p
    font-style: italic
    font-weight: normal
    font-size: 15px
    line-height: 119.69%
    color: #455A64
</style>